import React, { useState } from "react";
import NavbarTwo from "../../Components/Navbar/navbarTwo";
import Footer from "../../Components/Footer";
import BottomNavbar from "../../Components/Navbar/bottomNavbar";
import { FaUserAlt, FaPhoneAlt, FaMapMarkerAlt, FaPaintBrush } from "react-icons/fa";
import { MdEmail, MdOutlineVolunteerActivism } from "react-icons/md";
import { IoChevronDown } from "react-icons/io5";
import { HiOutlineSpeakerphone } from "react-icons/hi";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL!;

const divisions = [
  {
    value: "Content Kreator & Sosial Media",
    icon: HiOutlineSpeakerphone,
  },
  {
    value: "Pelaksana Program Lapangan",
    icon: MdOutlineVolunteerActivism,
  },
  {
    value: "Media & Design",
    icon: FaPaintBrush,
  },
];

const RelawanRegisterPage: React.FC = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    domicile: "",
    division: "",
    skills: "",
    motivation: "",
  });

  const [loading, setLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleChange = (e: any) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await fetch(`${API_BASE_URL}/api/volunteer/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      if (res.ok) {
        setShowSuccess(true);
        setForm({
          name: "",
          email: "",
          phone: "",
          domicile: "",
          division: "",
          skills: "",
          motivation: "",
        });

        setTimeout(() => setShowSuccess(false), 4000);
      }
    } catch (error) {
      console.error("Gagal daftar:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <NavbarTwo />

      <section className="bg-gray-100 py-24 md:py-32 font-signika">
        <div className="max-w-[800px] mx-auto px-4 md:px-8 ">
          <div className="bg-white shadow-3xl rounded-3xl relative overflow-hidden">
            <div className="h-2 bg-gradient-to-r from-[#29abe2] via-[#1f8ac0] to-[#8cc63f]" />
            <div className=" p-8 md:p-12">
              <h1 className="text-2xl md:text-3xl font-bold text-center mb-2">
                Gabung <span className="text-[#2596be]">Relawan</span>
              </h1>
              <p className="text-sm text-gray-400 text-center mb-8">Pilih peranmu dalam gerakan kebaikan.</p>

              <form onSubmit={handleSubmit} className="space-y-6">
                {/* Nama */}
                <InputField icon={FaUserAlt} placeholder="Nama Lengkap" name="name" value={form.name} onChange={handleChange} />

                {/* Email */}
                <InputField icon={MdEmail} placeholder="Email" name="email" value={form.email} onChange={handleChange} />

                {/* Phone */}
                <InputField icon={FaPhoneAlt} placeholder="No. HP" name="phone" value={form.phone} onChange={handleChange} />

                {/* Domisili */}
                <InputField icon={FaMapMarkerAlt} placeholder="Domisili" name="domicile" value={form.domicile} onChange={handleChange} />

                {/* Custom Dropdown Division */}
                <div className="relative">
                  <div onClick={() => setDropdownOpen(!dropdownOpen)} className="flex items-center justify-between border rounded-xl px-4 py-3 cursor-pointer hover:border-[#2596be]">
                    <span className={form.division ? "text-gray-800" : "text-gray-400"}>{form.division || "Pilih Divisi"}</span>
                    <IoChevronDown className={`transition ${dropdownOpen ? "rotate-180" : ""}`} />
                  </div>

                  {dropdownOpen && (
                    <div className="absolute w-full mt-2 bg-white border rounded-xl shadow-lg z-10 overflow-hidden">
                      {divisions.map((div, i) => {
                        const Icon = div.icon;
                        return (
                          <div
                            key={i}
                            onClick={() => {
                              setForm({ ...form, division: div.value });
                              setDropdownOpen(false);
                            }}
                            className="flex items-center gap-3 px-4 py-3 hover:bg-[#2596be]/10 cursor-pointer transition">
                            <Icon className="text-[#2596be]" />
                            <span>{div.value}</span>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>

                {/* Skills */}
                <textarea name="skills" placeholder="Keahlian" value={form.skills} onChange={handleChange} className="w-full border rounded-xl px-4 py-3 focus:border-[#2596be] outline-none" />

                {/* Motivation */}
                <textarea name="motivation" placeholder="Motivasi Bergabung" value={form.motivation} onChange={handleChange} className="w-full border rounded-xl px-4 py-3 focus:border-[#2596be] outline-none" />

                <button type="submit" disabled={loading} className="w-full bg-[#2596be] text-white py-3 rounded-xl font-semibold hover:opacity-90 transition">
                  {loading ? "Mengirim..." : "Daftar Sekarang"}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* SUCCESS POPUP */}
      {showSuccess && (
        <div className="fixed inset-0 flex items-center justify-center bg-black/40 z-50 animate-fadeIn">
          <div className="bg-white rounded-2xl p-8 text-center shadow-2xl animate-scaleUp">
            <h2 className="text-xl font-bold text-[#2596be] mb-2">🎉 Pendaftaran Berhasil!</h2>
            <p className="text-gray-600">Terima kasih telah mendaftar sebagai relawan.</p>
          </div>
        </div>
      )}

      <Footer />
      <BottomNavbar />

      {/* Animasi */}
      <style>
        {`
        .animate-fadeIn {
          animation: fadeIn 0.3s ease forwards;
        }
        .animate-scaleUp {
          animation: scaleUp 0.3s ease forwards;
        }
        @keyframes fadeIn {
          from { opacity: 0 }
          to { opacity: 1 }
        }
        @keyframes scaleUp {
          from { transform: scale(0.9); opacity: 0 }
          to { transform: scale(1); opacity: 1 }
        }
        `}
      </style>
    </>
  );
};

const InputField = ({ icon: Icon, ...props }: any) => (
  <div className="flex items-center border rounded-xl px-4 py-3 focus-within:border-[#2596be]">
    <Icon className="text-[#2596be] mr-3" />
    <input {...props} className="w-full outline-none" />
  </div>
);

export default RelawanRegisterPage;
